/**
 * Trusscore Cost & Materials Estimator
 *
 * Application Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { captureUtmParams } from './utils/utmParams';
import { captureUrlLocale } from './utils/urlLocale';
import { installGlobalErrorHandlers } from './utils/errorReporting';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';  // Bootstrap JS (collapse, dropdowns, etc.)
import './styles/bootstrap-custom.scss';  // Bootstrap + Trusscore overrides
import './styles/index.css';
import './styles/trusscore-theme.css';

// Snapshot UTM params from the landing URL before any SPA routing strips the
// query string — they ride along to Pardot when a guest estimate is submitted.
captureUtmParams();

// Likewise a language referral (/fr-ca or ?lang=fr-CA): remembered for
// LanguageContext to resolve, and stripped so the router sees a clean path.
// Must run before <Router> mounts — it reads window.location exactly once.
captureUrlLocale();

// Uncaught errors and unhandled rejections go to the dataLayer as
// `estimator_error` events (render crashes are reported by ErrorBoundary).
installGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
